var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"back-button__wrapper"},[_c('el-button',{staticClass:"el-button--submit",on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._v("\n    GO BACK\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }